import {OAuthResponseType, OktaAuth} from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';
export const oktaAuth = new OktaAuth({
    issuer: `${environment.securityConfig.issuer}`,
    clientId: `${environment.securityConfig.clientId}`,
    redirectUri: window.location.origin + '/callback',
    scopes: environment.securityConfig.scopes,
    responseType: ['code'] as OAuthResponseType | OAuthResponseType[],
    pkce: environment.securityConfig.pkce,
    postLogoutRedirectUri: window.location.origin,
      tokenManager: {
          autoRenew: true,
          storage:'localStorage'
      }
});

